import React from 'react'
import partial from 'lodash/partial'

import * as URLS from '../../urls'
import * as track from '../../track/other'

import AnchorNewTab from '../AnchorNewTab'

import '../../../scss/components/pdp/_grf-promo-banner.scss'

interface Props {
  showBuyPathExperiment: boolean
}
const GroomRentsFreePromoBanner: React.FC<Props> = ({showBuyPathExperiment}) => (
  <div className="c-grf-promo-banner">
    <p className="c-grf-promo-banner__label">
      <strong>{`Grooms ${showBuyPathExperiment ? 'get a $200 credit.' : 'rent free.'}`}</strong>
    </p>
    <p className="c-grf-promo-banner__label">
      {`Reserve wedding party looks, ${
        showBuyPathExperiment ? 'get a $200 credit off yours. ' : 'get yours free. '
      }`}
      <AnchorNewTab
        className="c-grf-promo-banner__link"
        href={URLS.WEDDINGS_LP_MANAGE_HASH}
        onClick={partial(track.clickedLink, {
          location: 'PDP Groom Rents Free Promo Banner',
          target: URLS.WEDDINGS_LP_MANAGE_HASH,
          text: 'Learn more',
        })}
      >
        Learn more
      </AnchorNewTab>
      .
    </p>
  </div>
)

export default GroomRentsFreePromoBanner
